export const MIN_IDENTITY_AGE_YEARS = 18;
export const MAX_IDENTITY_AGE_YEARS = 120;

export const normalizeIdentityDobSegment = (value, maxLength) => String(value || '')
  .replace(/[^\d]/g, '')
  .slice(0, maxLength);

export const shouldAutoAdvanceIdentityDobSegment = (value, expectedLength) => (
  normalizeIdentityDobSegment(value, expectedLength).length === expectedLength
);

export const validateIdentityDob = ({ month: monthRaw, day: dayRaw, year: yearRaw }, now = new Date()) => {
  const month = Number(String(monthRaw || '').trim());
  const day = Number(String(dayRaw || '').trim());
  const year = Number(String(yearRaw || '').trim());

  if (!Number.isInteger(month) || !Number.isInteger(day) || !Number.isInteger(year)) {
    return { valid: false, message: 'A valid date of birth is required.' };
  }
  if (month < 1 || month > 12) {
    return { valid: false, message: 'Please enter a valid birth month (01-12).' };
  }
  if (day < 1 || day > 31) {
    return { valid: false, message: 'Please enter a valid birth day (01-31).' };
  }
  if (year < 1900 || year > now.getFullYear()) {
    return { valid: false, message: 'Please enter a valid birth year.' };
  }

  const dob = new Date(year, month - 1, day);
  const isCalendarValid = dob.getFullYear() === year
    && dob.getMonth() === month - 1
    && dob.getDate() === day;
  if (!isCalendarValid) {
    return { valid: false, message: 'Please enter a real calendar date for your birth date.' };
  }

  let age = now.getFullYear() - year;
  const beforeBirthdayThisYear = now.getMonth() < month - 1
    || (now.getMonth() === month - 1 && now.getDate() < day);
  if (beforeBirthdayThisYear) age -= 1;
  if (age < MIN_IDENTITY_AGE_YEARS || age > MAX_IDENTITY_AGE_YEARS) {
    return { valid: false, message: 'A valid date of birth is required.' };
  }

  return { valid: true };
};

export const getIdentitySubmissionErrorMessage = (message, code = '') => {
  const raw = String(message || '').trim();
  const normalized = `${String(code || '')} ${raw}`.toLowerCase();
  if (normalized.includes('valid date of birth')) {
    return 'A valid date of birth is required.';
  }
  if (
    normalized.includes('identity_mismatch_on_device')
    || normalized.includes('device_blocked')
    || normalized.includes('device_velocity_exceeded')
    || normalized.includes('conflicting identity verification attempts')
  ) {
    return 'Multiple conflicting identity verification attempts were detected on this device.';
  }
  if (
    normalized.includes('astra_duplicate_user_detected')
    || normalized.includes('already-exists')
    || normalized.includes('already linked to an existing astra profile')
  ) {
    return 'This identity is already linked to an existing Clero account.';
  }
  if (normalized.includes('po box') || normalized.includes('p.o. box')) {
    return 'PO Box addresses are not accepted. Please use your residential street address.';
  }
  return raw || 'Unable to verify your identity. Please review your information and try again.';
};
